<template>
  <div class="d-flex flex-column">
    <h2 class="dmh-start-title brand-text">
      {{ pageContent.title }}
    </h2>
    <p class="dmh-start-subheading brand-text">
      {{ pageContent.subtitle }}
    </p>
    <div class="d-flex flex-column mb-5">
      <b-button
        @click="handleBtnClick"
        variant="cta"
        size="lg"
        class="align-self-end"
        >{{ pageContent.buttonText }}</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ProceedToSurvey",
  props: {
    pageContent: {
      type: Object,
      required: true,
      default: () => ({})
    },
    handleBtnClick: {
      type: Function,
      required: true,
      default: () => {}
    }
  }
};
</script>

<style lang="less"></style>
